import {
  bulkCredentialIssueSuccessIntro,
  bulkCredentialIssuingLabel,
  bulkCsvPanelProcessingMs,
  bulkIssueAllMobileModalBody,
  bulkIssueSingleMobileModalBody,
  bulkIssueSingleMobileModalTitle,
  bulkStaticDefaults,
  bulkUserSuccessBanner,
  bulkUserSuccessIntro,
  bulkUserSuccessNote,
  bulkUserSuccessStatsLine,
} from '@/config/static/catalog/bulk';

/** @deprecated Use staticDefaults.bulk.flowTitle */
export const BULK_USER_IMPORT_FLOW_TITLE = bulkStaticDefaults.flowTitle;

/** @deprecated Use staticDefaults.bulk.trustLine */
export const BULK_USER_IMPORT_TRUST_LINE = bulkStaticDefaults.trustLine;

/** @deprecated Use staticDefaults.bulk.progressRailSteps */
export const BULK_USER_PROGRESS_RAIL_STEPS = bulkStaticDefaults.progressRailSteps;

/** @deprecated Use staticDefaults.bulk.noCsvProgressRailSteps */
export const BULK_USER_NO_CSV_PROGRESS_RAIL_STEPS = bulkStaticDefaults.noCsvProgressRailSteps;

/** @deprecated Use staticDefaults.bulk.timing */
export const BULK_USER_IMPORT_TIMING = bulkStaticDefaults.timing;

/** @deprecated Use bulkCsvPanelProcessingMs from catalog */
export const BULK_USER_CSV_PANEL_PROCESSING_MS = bulkCsvPanelProcessingMs;

/** @deprecated Use staticDefaults.bulk.explainability */
export const BULK_USER_EXPLAINABILITY = bulkStaticDefaults.explainability;

/** @deprecated Use staticDefaults.bulk.noCsvAssistantHint */
export const BULK_USER_NO_CSV_ASSISTANT_HINT = bulkStaticDefaults.noCsvAssistantHint;

/** @deprecated Use staticDefaults.bulk.assistantHint */
export const BULK_USER_ASSISTANT_HINT = bulkStaticDefaults.assistantHint;

/** @deprecated Use staticDefaults.bulk.credentialIssueTiming */
export const BULK_CREDENTIAL_ISSUE_TIMING = bulkStaticDefaults.credentialIssueTiming;

/** @deprecated Use staticDefaults.bulk.credentialIssueNextSteps */
export const BULK_CREDENTIAL_ISSUE_NEXT_STEPS = bulkStaticDefaults.credentialIssueNextSteps;

export {
  bulkCredentialIssueSuccessIntro,
  bulkCredentialIssuingLabel,
  bulkIssueAllMobileModalBody,
  bulkIssueSingleMobileModalBody,
  bulkIssueSingleMobileModalTitle,
  bulkUserSuccessBanner,
  bulkUserSuccessIntro,
  bulkUserSuccessNote,
  bulkUserSuccessStatsLine,
};
